<script lang="ts">
	import PortableText from '$components/PortableText/PortableText.svelte';
	import type { PageData } from './$types';
	import ProfileStructuredData from './ProfileStructuredData.svelte';

	interface Props {
		data: PageData;
	}

	let { data }: Props = $props();

	console.log(data.content);
</script>

<svelte:head>
	<title>{data.title}</title>
	<meta name="description" content={data.title + ' - ' + data.description} />
</svelte:head>

<ProfileStructuredData />

<h1 class="page-title">{data.title}</h1>

<article class="prose-text-link-main prose mx-auto">
	<PortableText value={data.content} />
</article>
